import { render, staticRenderFns } from "./doorTime.vue?vue&type=template&id=283ec228&scoped=true"
import script from "./doorTime.vue?vue&type=script&lang=js"
export * from "./doorTime.vue?vue&type=script&lang=js"
import style0 from "./doorTime.vue?vue&type=style&index=0&id=283ec228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ec228",
  null
  
)

export default component.exports